import { render, staticRenderFns } from "./CommentLikeButton.vue?vue&type=template&id=a42f288a&"
import script from "./CommentLikeButton.vue?vue&type=script&lang=js&"
export * from "./CommentLikeButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports